import React, { useRef,useEffect,useState } from 'react'
 import { useStore } from './store'
import AppConfig from './Config.js';
import { useSpring, animated,useTrail } from 'react-spring';
import { Light } from 'three';
import { Howl, Howler } from 'howler';
import ReactHowler from 'react-howler';
import {useNavigate ,useLocation } from 'react-router-dom';
import './style.css';
const hostloca=AppConfig.cdnUrl;

let ballarray= create2DArray(8, 8, false);

let bgsound=false
let usehowler=false

let userscoretype='a'

function create2DArray(rows, cols, defaultValue) {
    return Array.from({ length: rows }, () => Array.from({ length: cols }, () => defaultValue));
  }


function DotMatrix(props) {
    const [matrix, setMatrix] = useState(ballarray);


   

    let ballsize=20
    let sw=window.innerWidth
    let sh=window.innerHeight
    let ballspace=sw/9
    let startx= (sw-(ballspace*7)-ballsize)/2 
    let starty=(sh-(ballspace*7)-ballsize)/2 -sh/32
    
    
  
    const triggerAnimation = (row, col) => {
      const newMatrix = matrix.map((rowArray, rowIndex) => 
        rowIndex === row ? rowArray.map((item, colIndex) => colIndex === col ? true : item) : rowArray
      );
      setMatrix(newMatrix);


    };

      useEffect(() => {
            
              let mk=props.mark
            if(mk.length>0){

             
                let resetcubegroup= create2DArray(8, 8, false); //reset ball
               for(let j=0;j<props.mark.length;j++){
                   resetcubegroup[mk[j][0]][mk[j][1]]=true
                 }
      
                ballarray=resetcubegroup
                setMatrix(resetcubegroup);
                
            }

          
        
        },[props])


    useEffect(() => {

      //  console.log(matrix)


        },[matrix])

    
  
    const calculateXMove = (colIndex,rowIndex) => {
      const startPos = colIndex * ballspace+startx+(colIndex-6)*5; // 每个点的起始X位置
      const endPos = sw/2; // 中心线位置
      return `${endPos - startPos}px`; // 计算需要移动的距离
    };

    const calculateYMove = (colIndex,rowIndex) => {
        const startPos = rowIndex * ballspace+starty; // 每个点的起始X位置
        const endPos = sh*.94-(rowIndex * ballspace)/10; // 中心线位置
        return `${endPos - startPos}px`; // 计算需要移动的距离
      };
  
    return (
      <div style={{ position: 'absolute', width: '100VW', height: '92vh', margin: 'auto',display:'flex',alignContent:'center',justifyContent:'center',pointerEvents:'none',overflow:'hidden' }}>
        {matrix.map((row, rowIndex) =>
          row.map((isActive, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className="dot"
              style={{
                left: `${colIndex * ballspace+startx}px`,
                top: `${rowIndex * ballspace+starty}px`,
                animation: isActive ? `moveToCenter ${1.5-rowIndex/12}s ease-out` : 'none',
                '--x-move': isActive ? calculateXMove(colIndex,rowIndex) : '0px', // 设置变量控制X轴移动
                '--y-move': isActive ? calculateYMove(colIndex,rowIndex) : '0px' // 设置变量控制X轴移动
              }}
              //onClick={() => triggerAnimation(rowIndex, colIndex)}
            />
          ))
        )}
      </div>
    );
  }
  
  

  const Confetti = (props) => {
    const [flloweralpha,setflloweralpha]=useState(1)
 
    const colors=['#B833EA','#CCE7AD','#EFEEEF','#D7D7D7','#CCE7AD','99B3F6','#EFEEEF','#CCE7AD']


    useEffect(()=>{

          if(props.scoretype=='c'){

            setflloweralpha(0)
          }else{

            setflloweralpha(1)
          }

    },[props])
 
  const boxes = Array.from({ length: 50 }, (_, index) => {
    const angle = Math.random() * 2 * Math.PI;
    const radius = 150 + Math.random() * 150;
    return {
      id: index,
      xOffset: Math.cos(angle) * radius + 'px', // Calculate the horizontal offset
      yOffset: Math.sin(angle) * radius + 'px', // Calculate the vertical offset
      rotateX: Math.random() * 360 + 'deg',     // Random X-axis rotation
      rotateY: Math.random() * 360 + 'deg',     // Random Y-axis rotation
      rotateZ: Math.random() * 360 + 'deg',     // Random Z-axis rotation
      scale: Math.random() * 0.5 + 0.5, // 确保大小不会太小
      randColor: colors[Math.floor(Math.random() * 8)],
      delay: Math.random() * 3*.1 // 随机延迟，最多5秒
    };
  });

  return (
    <div style={{position:'absolute',width:'100vw',height:'100vh',opacity:flloweralpha}}>

      {boxes.map(box => (
        <div
          key={box.id}
          className="box"
          style={{
            '--x-offset': box.xOffset,
            '--y-offset': box.yOffset,
            '--rotate-x': box.rotateX,
            '--rotate-y': box.rotateY,
            '--rotate-z': box.rotateZ,
            '--randColor': box.randColor,
            '--scale': box.scale,
            animationDelay: `${box.delay}s, ${box.delay}s`
          }}
        />
      ))}


    </div>
  );
      
  };

function FlipCard({ show ,score,scorestate,targetnum}) {
    const [flipped, setFlipped] = useState(false);

    const [carda, setcarda] = useState(false);
    const [cardb, setcardb] = useState(false);
    const [cardc, setcardc] = useState(false);


    const [cardurl, setcardurl] = useState('');
   
     
    // 控制卡片的上升和透明度动画，响应 `show` 状态的改变
    const riseProps = useSpring({
      to: {
        opacity: show ? 1 : 0, // 终止状态：显示时透明度为 1，隐藏时透明度为 0
        marginTop: show ? '-20vh' : '-100vh' // 初始位置在屏幕60%高度处，终止位置为屏幕中心
      },
      from: {
        opacity: 0, // 开始状态：透明度从 0 开始
        marginTop: '-100vh' // 初始位置从屏幕的 60% 高度开始
      },
      config: { duration: 700 } // 控制动画运行速度，这里设为1000毫秒
    });
  
    // 控制卡片翻转动画，响应 `flipped` 状态的改变
    const { transform, opacity } = useSpring({
      opacity: flipped ? 1 : 0,
      transform: `perspective(1000px) rotateY(${flipped ? 180 : 0}deg)`,
      config: { mass: 5, tension: 500, friction: 80 }
    });


    useEffect(() => {
    
      
        if(scorestate=='a'){
         setcarda(true)
        }else if(scorestate=='b'){
         setcardb(true)
        }else if(scorestate=='c'){
         setcardc(true)
        }


        let imgurl=hostloca+'Assets/card'+targetnum+'.png'

        setcardurl(imgurl)
  
      }, [scorestate]); // 依赖于 show
  
      
  
    // 设置自动翻转
    useEffect(() => {
      let timer;
      if (show) {
        timer = setTimeout(() => {
        if(scorestate!='c')setFlipped(true);
        }, 4400); // 4秒后自动翻转
        return () => clearTimeout(timer);
      } else {
        setFlipped(false); // 重置翻转状态
      }


     

    }, [show]); // 依赖于 show
  
    return (
      <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <animated.div style={{
          ...riseProps,
          width: '70vw',
          height: '300px',
          borderRadius: '0px',
          position: 'absolute',
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden',
          transform: transform.interpolate(t => `${t} rotateY(0deg)`),
          opacity: opacity.interpolate(o => 1 - o),
        }}>
           <div style={{position:'absolute',width:'100%',top:0}}>
           <img  src={hostloca+'Assets/flipcarda.png'} style={{width:'100%'}}/> 
           

           </div>

                             {carda? (
                                     <div style={{width:'100%',height:'12vw',position:'absolute',top:'6vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        <span className='textcard' style={{fontSize:'8vw',letterSpacing:'.4vw',paddingTop:'0',paddingLeft:'0vw',position:'absolute',color:'white'}}>Excellent!</span>  
                                        <span className='textnormal' style={{fontSize:'3.5vw',letterSpacing:'1vw',top:'10vh',fontWeight:600,paddingLeft:'0vw',position:'absolute',color:'white'}}>收集完成!</span>  
                                        <span className='textnormal' style={{fontSize:'5vw',letterSpacing:'.5vw',left:'20vw',top:'16vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>分数： </span>  
                                        <span className='textcard' style={{fontSize:'6vw',letterSpacing:'.5vw',left:'36vw',top:'16vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{score} </span>  
                                        <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'20vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>您成功超越80%的玩家</span>  
                                        <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'32vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>限定壁纸已解锁(1/3)</span>  
                                    </div>
                                ):('')}    

                                  {cardb? (
                                     <div style={{width:'100%',height:'12vw',position:'absolute',top:'6vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        <span className='textcard' style={{fontSize:'6vw',letterSpacing:'.4vw',paddingTop:'0',paddingLeft:'0vw',position:'absolute',color:'white'}}>Level Completed!</span>  
                                        <span className='textnormal' style={{fontSize:'3.5vw',letterSpacing:'1vw',top:'10vh',fontWeight:600,paddingLeft:'0vw',position:'absolute',color:'white'}}>收集完成!</span>  
                                        <span className='textnormal' style={{fontSize:'5vw',letterSpacing:'.5vw',left:'20vw',top:'16vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>分数： </span>  
                                        <span className='textcard' style={{fontSize:'6vw',letterSpacing:'.5vw',left:'37vw',top:'16vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{score} </span>  
                                        <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'20vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>您成功超越50%的玩家</span>  
                                        <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'30.5vh',paddingLeft:'3vw',position:'absolute',fontWeight:400,color:'white'}}>小提示：   </span>  
                                        <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'33vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>分数越高越机会解锁限定壁纸</span>  
                                    </div>
                                ):('')}      


                                  {cardc? (
                                     <div style={{width:'100%',height:'12vw',position:'absolute',top:'6vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        <span className='textcard' style={{fontSize:'7vw',letterSpacing:'.4vw',paddingTop:'0',paddingLeft:'0vw',position:'absolute',color:'white'}}>Try Again!</span>  
                                        <span className='textnormal' style={{fontSize:'3.5vw',letterSpacing:'.6vw',top:'15vh',fontWeight:600,paddingLeft:'0vw',position:'absolute',color:'white'}}>步数用尽</span>  
                                       <span className='textnormal' style={{fontSize:'3.5vw',letterSpacing:'.6vw',top:'17vh',fontWeight:600,paddingLeft:'0vw',position:'absolute',color:'white'}}>收集未完成</span>  
                                          
                                       <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'30.5vh',paddingLeft:'3vw',position:'absolute',fontWeight:400,color:'white'}}> 小提示：</span>  
                                        <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'33vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}> 成功通关即可解锁限定壁纸</span>  
                                    </div>
                                ):('')}        

        </animated.div>
        <animated.div style={{
          ...riseProps,
          width: '70vw',
          height: '300px',
          borderRadius: '0px',
          position: 'absolute',
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden',
          transform: transform.interpolate(t => `${t} rotateY(180deg)`),
          opacity,
        }}>
                    <div style={{position:'absolute',width:'100%'}}>
                    <img  src={hostloca+'Assets/flipcardb.png'} style={{width:'100%'}}/> 


                    </div>

                    <div style={{width:'100%',height:'12vw',position:'absolute',top:'6vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <div style={{position:'absolute',width:'96%',top:'-4vh'}}>
                    <img  src={cardurl} style={{width:'100%'}}/> 

                    </div>
                    </div>
        </animated.div>
      </div>
    );
  }

export default function Uilayer(props) {

   const state = useStore()
    const [score,setscore]=useState([0,0,0,60,0,20])
    const [numleft,setnumleft]=useState(2.6)
    const [showend,setshowend]=useState(false)
    const [endcardalpha,setendcardalpha]=useState(0)
    const [scorboardalopa,setscorboardalopa]=useState(0)

    const [scorestate,setscorestate]=useState('a')
    const [scorerecord,setscorerecord]=useState(0)

    const [nextplay,setnextplay]=useState('none')
    const [replay,setreplay]=useState('none')

    const [dotmark,setdotmark]=useState([])
    const [toggle, setToggle] =useState(false);
    const [toggletime, settoggletime] =useState(1000);
    const [playsound, setplaysound] =useState(false);
    const [playsound2, setplaysound2] =useState(false);
    const [playsound3, setplaysound3] =useState(false);   

    const [gamefinish, setgamefinish] =useState(false);   
    const [startalpha, setstartalpha] = useState(1);
    const [btnscale, setbtnscale] = useState([1,1]);
    const [collectfonts, setcollectfonts] = useState(['3.6vw','1vw']);
    
    
    let navigate =useNavigate();
    let location =useLocation()
    

        const sound = new Howl({
          src: [hostloca+'media/sound3.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
          // console.log('Sound effect has finished playing.');
          }
        });

        const soundg1 = new Howl({
          src: [hostloca+'media/sound1.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
        });

        const soundg2 = new Howl({
          src: [hostloca+'media/sound2.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
        });

        const soundg4 = new Howl({
          src: [hostloca+'media/ending.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
        });

        const soundbg = new Howl({
          src: [hostloca+'media/bg.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: true ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        const soundg5 = new Howl({
          src: [hostloca+'media/sound5.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: false ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        const soundg6 = new Howl({
          src: [hostloca+'media/sound6.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: false ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        const soundbg_32 = new Howl({
          src: [hostloca+'media/bgm3.3.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: true ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        const boom_sound = new Howl({
          src: [hostloca+'media/bgboom.mp3'],
          volume: 1,  // 设置音量，范围 0.0 到 1.0
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        const bonus_sound = new Howl({
          src: [hostloca+'media/Bonus.mp3'],
          volume: 1,  // 设置音量，范围 0.0 到 1.0
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
        });

        /**
         * audio soundeffect 
         */
        //======================================================================================
        
        const bgaudioRef = useRef(new Audio(hostloca+'media/bg.mp3'));
        const audioRef = useRef(new Audio(hostloca+'media/allsound.mp3'));
        const audioRefb = useRef(new Audio(hostloca+'media/allsound.mp3'));
        const [playSegment, setPlaySegment] = useState({ start: 0, end: 0 });
        const [playSegmentb, setPlaySegmentb] = useState({ start: 0, end: 0 });


        const soundbgm=()=>{
          let bgaudio= bgaudioRef.current
          bgaudio.volume = 0.1;
          bgaudio.autoplay = true;
          bgaudio.loop = true;
          bgaudio.play();
          }

       

          useEffect(()=>{
              const bgaudio = bgaudioRef.current;
              if (!bgaudio) return;
            

              const handlePlay = () => {
                bgsound=true
                console.log("Audio is playing");
              };

              bgaudio.addEventListener('play', handlePlay);
              return () => {
                bgaudio.removeEventListener('play', handlePlay);
             
          };

          },[])


        useEffect(() => {
          const audio = audioRef.current;
  
          const checkTime = () => {
              if (audio.currentTime >= playSegment.end) {
                  audio.pause();
                  // 可以根据需求设置是否重置时间
                  // audio.currentTime = playSegment.start;
              }
          };
  
          if (playSegment.start !== playSegment.end) {
              audio.currentTime = playSegment.start;
              audio.play();
              audio.addEventListener('timeupdate', checkTime);
          }
  
          return () => {
              audio.removeEventListener('timeupdate', checkTime);
          };
        }, [playSegment]);



          useEffect(() => {
            const audiob = audioRefb.current;
    
            const checkTimeb = () => {
                if (audiob.currentTime >= playSegmentb.end) {
                  audiob.pause();
                    // 可以根据需求设置是否重置时间
                    // audio.currentTime = playSegment.start;
                }
            };
    
            if (playSegmentb.start !== playSegmentb.end) {
              audiob.currentTime = playSegment.start;
              audiob.play();
              audiob.addEventListener('timeupdate', checkTimeb);
            }
    
            return () => {
              audiob.removeEventListener('timeupdate', checkTimeb);
            };
          }, [playSegmentb]);


 



       const playAudioSegment = (start, end) => {
        setPlaySegment({ start, end });
       };

       const playAudioSegmentb = (start, end) => {
         setPlaySegment({ start, end });
        
       };
       

       
       const soundtouch = () => {
        playAudioSegment(0,1.8);
       };

       const soundscore = () => {
        playAudioSegment(2,3.7);
       };

       const sounddelete = () => {
        playAudioSegment(4,5.7);
       };

       const soundeffectc = () => {
        playAudioSegmentb(6.6,7.7);
       };

       const soundbonus = () => {
        playAudioSegmentb(8,9.7);
       };

       const soundboom = () => {
        playAudioSegmentb(10,11.7);
       };

       const soundendding = () => {
        playAudioSegmentb(12,14.7);
       };

       const soundenddingb = () => {
        playAudioSegmentb(15,16.7);
       };


         
           
        //=======================================================================================



    useEffect(()=>{


        if(!state.loaded)return

        let endgame=state.endgame
      
        if(state.startgame==1 && scorboardalopa==0){

            setscorboardalopa(1)
           
            
        }
        
       
       
        if(endgame==1 && scorboardalopa==1){


            if(gamefinish==false){

              setgamefinish(true)

            setscorboardalopa(0)
            setshowend(true)
            setTimeout(() => {
                setendcardalpha(1)

               
            }, 300);

      
      
           //成绩判定  3 type score
            if(state.collect<=0){

                if(scorerecord==0){
                    setscorestate('a')
                    userscoretype='a'
                }else  if(scorerecord==1){
                    setscorestate('b')
                    userscoretype='b'
                }
            
                setTimeout(() => {
                    setnextplay('flex')
                    setreplay('none')
                }, 4000);
              
                 if(usehowler)soundg4.play()
                 soundendding()

            }else{
                 setscorestate('c')  
                 userscoretype='c'
                 setnextplay('none')
                 setreplay('flex')

                 if(usehowler)soundg6.play()
                 soundenddingb()
            }

          }
        
       

       }else{
   
            
            let sc=state.count

            
            
                if(sc<10){
                    sc='00'+sc
                }else if(sc>=10 && sc <100){
                    sc='0'+sc
                }
            
            let str = sc.toString();  // 将数字转换为字符串
                let chars = str.split('');  
                let tagetnum=state.num

                //特殊处理0
                if(state.num==23){
                  tagetnum=0
                }

                chars.push(state.step)
                chars.push(tagetnum)
                chars.push(state.collect)
                console.log('score : '+sc)
                setscore(chars)
               
              

                if(tagetnum>=10){
                  setcollectfonts(['3vw','0vw'])
                }else{
                  setcollectfonts(['3.6vw','0vw'])
                }

                if(chars[0]==1 && numleft!=3.1){
                    setnumleft(3.1)

                }else if(chars[0]!=1  && numleft==3.1){
                    setnumleft(2.6)
                }

                if(sc>0){

                  if(usehowler)soundg2.play();
                  
                  soundscore()
               
                }

               

               
               if(state.mark.length>0){
                    setdotmark(state.mark)
                  //  let mk=state.mark[state.mark.length-1][0]
                   // settoggletime((10-mk)*100)
                    setToggle(true)
                 
                    if(usehowler)soundg1.play();
                    sounddelete()
                   
               }
                
 
            
            }

    

    }, [state.count,state.endgame,state.startgame])


    useEffect(()=>{
      //滑动小球
     if(state.touch){
      
      if(usehowler)sound.play();
      soundtouch()
     }
        if(bgsound==false ){
          
         
            if(usehowler)soundbg.play()
             soundbgm()
            
     
        }
  
      
    }, [state.touch])


    useEffect(()=>{
     
      if(bgsound==false ){
 
          if(usehowler)soundbg.play()
           soundbgm()
         
     
      }
  
      
    }, [state.gamestate])



    useEffect(()=>{
     
         if(  state.boom==true){
          if(usehowler)boom_sound.play()
         soundboom()
     
          state.boom=false

          
         }
      
    }, [state.boom])

    useEffect(()=>{
     
      if(  state.bonus==true){
        if(usehowler)bonus_sound.play()
       soundbonus()
  
       state.bonus=false
 
      }
   
   }, [state.bonus])
    

    useEffect(()=>{
     
      if(state.effectc){
        if(usehowler)soundg5.play();
        soundeffectc()
        state.effectc=false

      }
        
      }, [state.effectc])

    const collectprops = useSpring({
        to: { transform: `scale(${toggle ? 1.5 : 1})` },
        from: { transform: 'scale(1)' },
        reset: true,
        reverse: toggle,
        delay:0,
        onRest: () => {
            setToggle(!toggle)
        },
      });


      



     function backhome(){
      //  navigate('/',{state:{id:0,nick:''}})
      window.location.replace('/')
     }


    function replaygame(){

 
        setshowend(false)

        setTimeout(() => {
            setendcardalpha(0)

            setscorboardalopa(1)

            setgamefinish(false)

        }, 1000);

        setbtnscale([1,1,.5])
        props.callback()

    }


    function viewmycard(){
      setshowend(false)
          setbtnscale([.5,1,1])

          if(state.gamestate==1){
            window.location.replace('/mycard?s=1')
           }else if(state.gamestate==2){
            window.location.replace('/mycard?s=2')
           }else if(state.gamestate==3){
            window.location.replace('/mycard?s=3')
           }

    }

    function playnext(){

         setshowend(false)
         setbtnscale([1,.5,1])

         if(state.gamestate==1){
          window.location.replace('/g2')
         }else if(state.gamestate==2){
          window.location.replace('/g3')
         }else if(state.gamestate==3){
          window.location.replace('/g1')
         }


    }




    return  <div>
       
                <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center',pointerEvents:'none',opacity:scorboardalopa,transition:`all .5s`}}>         


                           {/*score   */}   
                        <div style={{width:'28vw',height:'12vw',position:'absolute',top:'13vh'}}>

                            <img  src={hostloca+'Assets/scoreboard.png'} style={{width:'100%'}}/> 
                                  
                        </div>

                        <div style={{width:'28vw',height:'12vw',position:'absolute',top:'13vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'0vw',position:'absolute',left:numleft+'vw'}}>{score[0]}</span>
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'6vw',position:'absolute'}}>{score[1]}</span>  
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'0vw',position:'absolute',left:'22vw'}}>{score[2]}</span> 
                        </div>

                                  {/*step   */}  
                       
                                     <div style={{width:'50vw',height:'12vw',position:'absolute',top:'4vh'}}>

                                    <img  src={hostloca+'Assets/step.png'} style={{width:'100%'}}/> 
                                        
                                    </div>


                                                
                                    <div style={{width:'28vw',height:'12vw',position:'absolute',top:'6.5vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        
                                        <span className='textstep' style={{fontSize:'6vw',letterSpacing:'1vw',paddingTop:'0',paddingLeft:'1.5vw',position:'absolute'}}>{score[3]}</span>  
                                        
                                    </div>





                            {/*collection   */}    


                                                     <div style={{width:'30vw',height:'12vw',position:'absolute',top:'90vh'}}>

                                                    <img  src={hostloca+'Assets/collection.png'} style={{width:'100%'}}/> 
                                                        
                                                    </div>

                                                    <div style={{width:'28vw',height:'12vw',position:'absolute',top:'88.5vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        
                                                    <span className='textscore' style={{fontSize:collectfonts[0],letterSpacing:'.2vw',paddingTop:'0',paddingLeft:collectfonts[1],position:'absolute'}}>{score[4]}</span>  
                                        
                                                    </div>

                                                    <animated.div style={{...collectprops,width:'28vw',height:'12vw',position:'absolute',top:'88.4vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        
                                                    <span className='textcollect' style={{fontSize:'4vw',letterSpacing:'0.2vw',paddingTop:'.5vw',paddingLeft:'19vw',position:'absolute'}}>{score[5]}</span>  
                                                    <span className='textcollect' style={{fontSize:'4vw',letterSpacing:'0.4vtruew',paddingTop:'0vw',paddingLeft:'11vw',position:'absolute'}}>x</span>  
                                        
                                                    </animated.div>
                                                    


 
                </div>

              

                

                {showend? (
                 <div style={{opacity:endcardalpha,transition:`all 1s`}}>
                  <div  style={{width:'100vw',height:'100vh',position:'absolute',left:'0',top:'0',display:'flex',justifyContent:'center',alignItems:'center',zIndex:400}}>
                   
                 <Confetti scoretype={scorestate} />
                 </div>

                <FlipCard show={showend}  score={score[0]+score[1]+score[2]} scorestate={scorestate} targetnum={score[4]}/>

                
                <div onClick={()=>viewmycard()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'15%',top:'76vh',display:nextplay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw',border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[0]}}>查看收集进度</div>


                <div onClick={()=>playnext()} style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'53%',top:'76vh',display:nextplay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[1]}}>挑战下一关</div>

                <div onClick={()=>replaygame()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'35%',top:'76vh',display:replay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[2]}}>重新挑战</div>



                </div>
                ):('')}
                {/*
             {playsound? (
              <ReactHowler src={hostloca+'media/sound2.mp3'} playing={playsound} />

             ):('')}

                {playsound2? (
              <ReactHowler src={hostloca+'media/sound1.mp3'} playing={playsound2} />

             ):('')}

             
            {playsound3? (
              <ReactHowler src={hostloca+'media/sound3.mp3'} playing={playsound3} />

             ):('')} */}

              <DotMatrix mark={dotmark} />

            



              <div onClick={()=>backhome()} className='btnnohightline'  style={{width:'7vw',height:'7vw',position:'absolute',top:'3vh',left:'5vw',opacity:scorboardalopa}}>

            <img  src={hostloca+'Assets/back.png'} style={{width:'100%'}}/> 
                
            </div>

 

         </div>

 

}